module.exports = __webpack_public_path__ + "static/img/agent-reg-background.b44cc9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-reg-background.png
// module id = Y//h
// module chunks = 1